var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackgroundpatterndecorative(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 461,
    viewBox: "0 0 480 461",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12521_6112",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -19,
    width: 480,
    height: 480
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 480,
    height: 480,
    transform: "translate(0 -19)",
    fill: "url(#paint0_radial_12521_6112)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12521_6112)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12521_6112)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_12521_6112)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -19,
    x2: 0.5,
    y2: 461,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.5,
    y1: -19,
    x2: 32.5,
    y2: 461,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 64.5,
    y1: -19,
    x2: 64.5,
    y2: 461,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.5,
    y1: -19,
    x2: 96.5,
    y2: 461,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 128.5,
    y1: -19,
    x2: 128.5,
    y2: 461,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.5,
    y1: -19,
    x2: 160.5,
    y2: 461,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 192.5,
    y1: -19,
    x2: 192.5,
    y2: 461,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 224.5,
    y1: -19,
    x2: 224.5,
    y2: 461,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 256.5,
    y1: -19,
    x2: 256.5,
    y2: 461,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 288.5,
    y1: -19,
    x2: 288.5,
    y2: 461,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320.5,
    y1: -19,
    x2: 320.5,
    y2: 461,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 352.5,
    y1: -19,
    x2: 352.5,
    y2: 461,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 384.5,
    y1: -19,
    x2: 384.5,
    y2: 461,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.5,
    y1: -19,
    x2: 416.5,
    y2: 461,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 448.5,
    y1: -19,
    x2: 448.5,
    y2: 461,
    stroke: "#EAECF0"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -18.5,
    width: 479,
    height: 479,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_12521_6112)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: 12.5,
    x2: 480,
    y2: 12.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 44.5,
    x2: 480,
    y2: 44.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 76.5,
    x2: 480,
    y2: 76.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 108.5,
    x2: 480,
    y2: 108.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 140.5,
    x2: 480,
    y2: 140.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 172.5,
    x2: 480,
    y2: 172.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 204.5,
    x2: 480,
    y2: 204.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 236.5,
    x2: 480,
    y2: 236.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 268.5,
    x2: 480,
    y2: 268.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 300.5,
    x2: 480,
    y2: 300.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 332.5,
    x2: 480,
    y2: 332.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 364.5,
    x2: 480,
    y2: 364.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 396.5,
    x2: 480,
    y2: 396.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 428.5,
    x2: 480,
    y2: 428.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 460.5,
    x2: 480,
    y2: 460.5,
    stroke: "#EAECF0"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -18.5,
    width: 479,
    height: 479,
    stroke: "#EAECF0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_12521_6112",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(240 240) rotate(90) scale(240 240)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12521_6112"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 480,
    height: 480,
    fill: "white",
    transform: "translate(0 -19)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_12521_6112"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -19,
    width: 480,
    height: 480,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_12521_6112"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -19,
    width: 480,
    height: 480,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundpatterndecorative);
export default __webpack_public_path__ + "static/media/Background pattern decorative.0ce7cfdf79876773c79d3367a2fc4eb2.svg";
export { ForwardRef as ReactComponent };